import React from 'react';
import Navbar from '../landing/Navbar';
import Footer from '../landing/Footer';

export default function SeoPageShell({ children }) {
  return (
    <div className="min-h-screen w-full max-w-full overflow-x-hidden bg-paper-alt">
      <Navbar />
      <main className="w-full max-w-full overflow-x-hidden">{children}</main>
      <Footer />
    </div>
  );
}
